/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {upsertFinancialProfileApp} from '../api'

export const useMutationUpsertFinancialProfileApp = createReactQueryMutationHook('upsertFinancialProfileApp', upsertFinancialProfileApp)
